export default __webpack_public_path__ + "static/media/video-sdg-5.4c42b3ee.mp4";